import { Component, input } from '@angular/core';
import { ProgressSpinner } from 'primeng/progressspinner';

@Component({
    selector: 'pn-progress-spinner',
    imports: [ProgressSpinner],
    templateUrl: './progress-spinner.html',
    styleUrl: './progress-spinner.scss',
})
export class PnProgressSpinner {
    /** Width of the circle stroke. Default: '2' */
    strokeWidth = input<string>('2');

    /** Color for the background of the circle */
    fill = input<string>('none');

    /** Duration of the rotate animation. Default: '2s' */
    animationDuration = input<string>('2s');

    /** Aria label for accessibility */
    ariaLabel = input<string>();
}
